/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrJobTypeEnum } from './irrJobTypeEnum';


/**
 * Contains arguments and metadata for invoking cloudrun job
 */
export interface GcpInvokeCloudRunJobSpec { 
    irr_id: string;
    /**
     * Cloud run job name.
     */
    job_name: string;
    job_type: IrrJobTypeEnum;
    container_image_name: string;
    zone: string;
    /**
     * Metadata for CloudRun job
     */
    metadata?: { [key: string]: string; };
}
export namespace GcpInvokeCloudRunJobSpec {
}


